
import request from "@/utils/request.js";
const baseURL = '/vote'

const api = {
    voteList: (data) => {
        return request({
            url: baseURL + "/api/wxzjzhfwyzxx/selectYzcytpxx",
            method: "post",
            data,
        });
    },
    // 投票信息
    getInfo: (params) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/getYzcytpxq`,
            method: "get",
            params
        })
    },
    getYzInfo: (id) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/getYzcytpxq/${id}`,
            method: "get",
        })
    },
    // 参与投票
    cytp: (data) => {
        return request({
            url: baseURL + `/api/wxzjzhfwyzxx/cytp`,
            method: "post",
            data
        })
    }
}
export default api
